import { IconBtc, IconGram, IconEtc, IconRvn, IconLTC } from '@/shared/ui/Icons';

export const GRAM_COIN = 'GRAM';
export const BTC_COIN = 'BTC';
export const LTCBTC_COIN = 'LTCBTC';
export const LTC_COIN = 'LTC';

export const accountCoins = [
  'BTC',
  // 'GRAM',
  'LTCBTC',
  'ETC',
  'RVN',
  // 'KAS', // shutodown kaspa
  // 'DNX',
];

export const networkCoins = {
  BTC: 'BTC',
  // GRAM: 'TON',
  LTCBTC: 'LTCBTC',
  LTC: 'LTCBTC',
  ETC: 'ETC',
  RVN: 'RVN',
}

export const DEFAULT_COIN = accountCoins[0];

export const COINS_MAP = {
  'BTC': {
    name: 'Bitcoin',
    symbol: 'BTC',
    icon: IconBtc,
  },
  // 'GRAM': {
  //   name: 'Gram',
  //   symbol: 'GRAM',
  //   icon: IconGram,
  // },
  'LTCBTC': {
    name: 'Ltc',
    symbol: 'LTC',
    icon: IconLTC,
  },
  'LTC': {
    name: 'Ltc',
    symbol: 'LTC',
    icon: IconLTC,
  },
  'ETC': {
    name: 'Etc',
    symbol: 'ETC',
    icon: IconEtc,
  },
  'RVN': {
    name: 'Rvn',
    symbol: 'RVN',
    icon: IconRvn,
  },
  // 'KAS': {
  //   name: 'Kaspa',
  //   symbol: 'KAS',
  //   icon: IconKaspa,
  // },
  // 'DNX': {
  //   name: 'Dynex',
  //   symbol: 'DNX',
  //   icon: IconDynex,
  // },
};

// Mapping from internal coin identifiers to display names
export const COIN_DISPLAY_NAMES = {
  'LTCBTC': 'LTC',
};

// Utility function to get display name for a coin
export const getCoinDisplayName = (coin: string): string => {
  return COIN_DISPLAY_NAMES[coin as keyof typeof COIN_DISPLAY_NAMES] || coin;
};
